<script setup lang="ts">
defineProps<{ describedBy: string; disabled?: boolean }>()
const accepted = defineModel<boolean>({ default: false })
const id = useId()
</script>

<template>
  <!-- The whole card is the label/touch target. Native checkbox semantics keep
       Space, the required state and the terms available to assistive tech. -->
  <label
    :for="id"
    data-testid="checkout-trial-consent"
    class="flex min-h-12 cursor-pointer items-start gap-3 rounded-lg border border-accented bg-elevated p-3 text-default focus-within:ring-2 focus-within:ring-inverted focus-within:ring-offset-2 focus-within:ring-offset-default"
    :class="{ 'cursor-wait opacity-60': disabled }"
  >
    <input
      :id="id"
      v-model="accepted"
      type="checkbox"
      required
      :disabled="disabled"
      :aria-describedby="describedBy"
      class="mt-0.5 size-5 shrink-0 cursor-pointer accent-[var(--ui-text)]"
    >
    <span class="text-sm font-medium leading-5">{{ $t('trial.accept') }}</span>
  </label>
</template>
